import { useEffect, useState } from 'react';
import { api } from '../../api';
import type { TopicInfo } from '../../types';
import styles from './TopicsList.module.css';

interface TopicsListProps {
  onSelectTopic: (topic: TopicInfo) => void;
}

export function TopicsList({ onSelectTopic }: TopicsListProps) {
  const [topics, setTopics] = useState<TopicInfo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.getTopics()
      .then((res) => {
        if (!cancelled && res.success) {
          setTopics(res.topics);
        }
      })
      .catch((err) => {
        console.error('Failed to load topics:', err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return <div className={styles.loading}>Загрузка тем...</div>;
  }

  if (topics.length === 0) return null;

  return (
    <div className={styles.container}>
      <h4 className={styles.header}>Интерпретация</h4>
      <div className={styles.grid}>
        {topics.map((topic) => (
          <button
            key={topic.key}
            className={styles.card}
            onClick={() => onSelectTopic(topic)}
          >
            <span className={styles.icon}>{topic.icon}</span>
            <div className={styles.nameRow}>
              <span className={styles.name}>{topic.name}</span>
              {topic.isPaid && <span className={styles.lock}>🔒</span>}
            </div>
            <span className={styles.description}>{topic.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
